import { IsAdminAction, IsAdminActionType } from './IsAdmin.action-types';
import { IIsAdminState } from './IsAdmin.types';

const initialState: IIsAdminState = {
    isAdmin: false,
    isLoading: false,
};

export const IsAdminReducerName = 'IsAdmin';

export function isAdminReducer(state: IIsAdminState = initialState, action: IsAdminAction) {
    switch (action.type) {
        case IsAdminActionType.REQUEST_IS_ADMIN: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case IsAdminActionType.RECEIVE_IS_ADMIN: {
            return {
                ...state,
                isAdmin: action.isAdmin,
                isLoading: false,
            };
        }
        default:
            return state;
    }
}
